"use strict";

REATOA.pageScript = REATOA.pageScript || {
  init: {}
};
REATOA.pageScript = function () {
  // コンストラクタ  =================================================================
  function init() {
    console.log('top.js');
    initHeaderToggle();

    // 完全にロードが終わってからスライダーを初期化
    $(window).on('load', function () {
      initInfoSlider();
      initMvSlider();
      initProductSlider();
    });
  }
  function initHeaderToggle() {
    var $header = $('.js-header');
    var $topMv = $('.js-topMv');
    var isHeaderVisible = false; // 現在の表示状態を管理

    function checkHeaderVisibility() {
      if ($topMv.length) {
        var topMvBottom = $topMv.offset().top + $topMv.outerHeight();
        var scrollTop = $(window).scrollTop();
        var shouldShow = scrollTop > topMvBottom;

        // 状態が変わった時のみクラスを操作
        if (shouldShow && !isHeaderVisible) {
          $header.addClass('is-show');
          isHeaderVisible = true;
        } else if (!shouldShow && isHeaderVisible) {
          $header.removeClass('is-show');
          isHeaderVisible = false;
        }
      }
    }
    $(window).on('scroll resize load', checkHeaderVisibility);
  }
  function initInfoSlider() {
    var topInfoSlider = new Swiper('.js-topInfo', {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      }
    });
  }
  function initMvSlider() {
    var $progressBar = $('.js-topMvCounterProgressBar');
    var $counter = $('.js-topMvCounterCurent');
    var AUTOPLAY_DELAY = 3000;
    var ANIMATION_START_DELAY = 50;

    // プログレスバーをリセット
    var resetProgressBar = function resetProgressBar() {
      $progressBar.css({
        height: '0%',
        transition: 'none'
      });
    };

    // プログレスバーアニメーション開始
    var startProgressBar = function startProgressBar() {
      setTimeout(function () {
        $progressBar.css({
          height: '100%',
          transition: "height ".concat(AUTOPLAY_DELAY, "ms linear")
        });
      }, ANIMATION_START_DELAY);
    };

    // カウンター更新
    var updateCounter = function updateCounter(realIndex) {
      $counter.text(realIndex + 1);
    };

    // 初期化
    resetProgressBar();
    var topMvSlider = new Swiper('.js-topMvSlider', {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: AUTOPLAY_DELAY,
        disableOnInteraction: false
      },
      speed: 1000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      on: {
        init: function init() {
          updateCounter(this.realIndex);
          // 初期化完了後にプログレスバー開始
          startProgressBar();
        },
        slideChange: function slideChange() {
          updateCounter(this.realIndex);
          resetProgressBar();
        },
        slideChangeTransitionEnd: function slideChangeTransitionEnd() {
          startProgressBar();
        }
      }
    });
  }
  function initProductSlider() {
    var topProdustsSlider = new Swiper('.js-topProdustsSlider', {
      slidesPerView: "auto",
      additionalSlides: 1,
      spaceBetween: 16,
      loop: false,
      mousewheel: {
        forceToAxis: true
      },
      navigation: {
        nextEl: '.js-topProdustsControlNext',
        prevEl: '.js-topProdustsControlPrev'
      }
    });
  }
  return {
    init: init
  };
}();
REATOA.common.init(REATOA.pageScript.init);